export const FRENCH = {
  link: {
    login: "/login",
    register: "/register",
    about: "/about",
    search: "/search",
    contact: "/contact",
    website: "/website",
    categories: "/categories",
    categorySelected: "/categories/:name",
    offers: "/offers",
    legal: "/legal",
    terms: "/terms_of_use",
    privacy: "/privacy",
    faq: "/faq",
    orderSummary: "/order_summary",
    payementConfirmation: "/payment_confirmation",
    payementCancel: "/payment_error",

    account: "/my_account",
    addCompany: "/my_account/add_company",

    manageCompany: "/my_account/manage_company/:id/",
    updateCompany: "/my_account/manage_company/:id/update",
    addWebsite: "/my_account/manage_company/:id/add_website",
    selectOffer: "/my_account/manage_company/:id/select_offers",
    manageOffer: "/my_account/manage_company/:id/manage_offers",

    manageWebsite: "/my_account/manage_website/:id/",
    updateWebsite: "/my_account/manage_website/:id/update",

    addPages: "/my_account/manage_website/:id/add_page",
    updatePage: "/my_account/manage_website/:id/update_page/:pageId/",

    admin: "/admin",
  },

  header: {
    home: "Accueil",
    categories: "Catégories",
    about: "À propos",
    offers: "Nos offres",
    dashboard: "Tableau de bord",
    connection: "Connexion",
    join: "S'inscire",
    logOut: "Déconnexion",
  },

  home: {
    banner: {
      title: "Nous aidons votre entreprise à être plus visible en ligne",
      subtitle: "Inscrivez-vous afin d'améliorer votre visibilité sur le web !",
    },
  },

  highLighted: {
    title: { text: "Mise en avant des", strong: "sites internet" },
  },

  joinedBusiness: {
    title: { text: "Derniers", strong: "sites inscrits" },
  },

  sectionCategories: {
    title: { text: "Les catégories de", strong: "sites internet" },
  },

  sectionWhy: {
    title: { text: "Pourquoi ", strong: "rejoindre 1 Top Search ?" },
    img: {
      view: "Nombre de vue",
      seo: "Augmentation du SEO",
      joined: "Sites inscrits",
    },
  },

  sectionOffer: {
    title: { text: "Nos", strong: "offres" },
  },

  search: {
    title: { text: "Rechercher un", strong: "site internet" },
    labelCompany: "ENTREPRISE",
    labelCategory: "CATÉGORIE",
    labelWhere: "OÙ",
    allCategories: "Toutes les catégories",
    noResult: "Oups, il n'y a aucun site correspondant à votre recherche...",
  },

  categories: {
    categoriesList: { single: "Catégorie", multiple: "Catégories" },
    lastWebsites: { text: "Les derniers", strong: "sites" },
    JoinUsBlock: {
      title: "Vous n'êtes pas encore inscrit ? Rejoignez-nous !",
      subtitle:
        "Inscrivez votre entreprise et votre site internet pour améliorer votre visibilité !",
    },
    noResult: "Il n'y a aucun site internet pour cette catégorie.",
  },

  login: {
    title: "Connexion",
    subtitle:
      "Cet espace est personnel et privé et vous permet de gérer directement votre compte, vos entreprises et vos sites.",
  },

  register: {
    title: "Inscription",
    subtitle: "Créer votre compte et gérer vos entreprises et vos sites.",
    alreadyMember: "Vous êtes déjà membre ?",
  },

  account: {
    title: "Mon compte",
    companies: {
      total: { single: "Entreprise", multiple: "Entreprises" },
      btns: {
        manage: "Gérer mes entreprises",
        add: "Ajouter une entreprise",
      },
      noCompanies: "Aucune entreprise",
    },

    manageAccount: {
      title: "Gérer mon compte",
      name: "Nom : ",
      email: "E-mail : ",
      role: "Rôle : ",
      btns: {
        edit: "Modifier mes infos",
      },
    },

    helps: {
      title: "Besoin d'aide ?",
      text: "Vous rencontrez des problèmes avec votre compte ? Vous avez besoin d'aide ? Contactez-nous pour plus d'information.",
    },
  },

  footer: {
    legal: "Mentions légales",
    terms: "Conditions Générales",
    privacy: "Confidentialité",
    faq: "FAQ",
  },

  pageLoader: "Chargement de la page... Merci de patienter.",

  websiteCard: {
    new: "Nouveau",
    top: "Top",
    websiteOfTheDay: "Le site du jour",
  },

  categoryCard: {
    site: "Site internet",
    sites: "Sites internet",
  },

  helperBoxes: {
    why: "Pourquoi rejoindre 1 Top Search ?",
    about: "À propos de 1 Top Search ?",
    question: "Une question ? Contactez-nous.",
  },

  searchPage: {
    noResult: "Oups, nous n'avons trouvé aucun site internet correspondant à votre recherche...",
    result: "Résultats pour",
    all: { text: "Tous les", strong: "sites internet" },
    btnAdd: "Ajouter un site",
    found: "professionnels trouvés",
  },

  seeAlso: {
    noResult: "Il n'existe pas d'autres sites dans cette catégorie.",
  },

  contactPage: {
    title: "Contact",
    subtitle: "Vous pouvez nous envoyer toute demande ici. Remplissez les champs ci-dessous.",
    thanks: "Merci pour votre message",
    getBack: "Nous revenons vers vous très rapidement",
  },

  placeHolder: {
    email: "E-mail",
    firstName: "Prénom",
    lastName: "Nom",
    subject: "Objet",
    message: "Message...",
    password: "Mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    country: "Pays - ex : France",
    city: "Ville - ex : Paris",
    street: "Rue - ex : 1 bis chemin du prevert",
    codePost: "Code postal - ex : 75001",
    companyName: "Nom de l'entreprise - ex : Google",
    companyCode: "Code de l'entreprise - ex : 877554",
    taxeNumber: "N° TVA - ex :  12345678A",
    websiteName: "Nom - ex : Google",
    host: "Hébergeur - ex : google.com",
    description: "Description...",
    pageName: "Nom de la page - ex : About",
    path: "Lien - ex : www.myWebsite.com/about",
    selectCategories: "Sélectionner catégories",
    selectLang: "Sélectionner une langue",
    searchName: "ex : Google",
    searchCategory: "ex : Agence web",
    searchWhere: "ex : Paris",
    userEmail: "Email utilisateur",
  },

  editInfo: {
    title: "Modifier mes informations",
    succes: "Bravo !",
  },

  forgotPassword: {
    title: "Mot de passe oublié",
    subtitle: "Veuillez renseigner votre adresse e-mail",
    sent: "Un e-mail vous a été envoyé",
    checkYourMail: "Vérifiez votre boîte mail",
  },

  manageCompany: {
    title: "Gestion des entreprises",
    Company: "Entreprise",
    address: "Adresse",
    companyCode: "Code de l'entreprise",
    vat: "N° TVA",
    companyWebsite: "Site internet",
    noWebsite: "Aucun site",
    addWebsite: "Ajouter un site internet",
    status: "Statuts",

    companyPacks: {
      title: "Pack Entreprise",
      offerStart: "Début de l'offre",
      offerEnd: "Fin de l'offre",
      totalWebsites: "Nombre total de sites",
      totalPages: "Nombre total de pages",
    },
  },

  manageWebsite: {
    title: "Gestion des sites",
    websitePages: "Pages",
    noPages: "Aucune page",
    lang: "Langue",
    addPage: "Ajouter une page",
    description: "Description",
  },

  addCompany: {
    title: "Ajouter une entreprise",
    subtitle: "Veuillez remplir tous les champs ci-dessous",
    logoPreview: "Aperçu du logo",
    addLogo: "Ajouter un logo :",
    btnAdd: "Ajouter une entreprise",
    missingLogo: "Veuillez ajouter le logo",
  },

  addWebsite: {
    title: "Ajouter un site",
    subtitle: "Veuillez remplir tous les champs ci-dessous pour ajouter un site",
    category: "Sélectionner les catégories",
    language: "Choisir la langue",
    addImage: "Ajouter une image :",
    imagePreview: "Aperçu",
  }, // new

  addPage: {
    title: "Ajouter une page",
    subtitle: "Veuillez remplir tous les champs ci-dessous",
    addImage: "Ajouter une image :",
    imagePreview: "Aperçu",
  },

  updateCompany: {
    title: "Modifier l'entreprise",
    subtitle: "Veuillez modifier les champs ci-dessous",
  },

  updateWebsite: {
    title: "Modifier le site internet",
    subtitle: "Veuillez modifier les champs ci-dessous",
  },

  updatePage: {
    title: "Modifier la page",
    subtitle: "Veuillez modifier les champs ci-dessous",
  },

  resetPassword: {
    title: "Modifier le mot de passe",
    subtitle: "Veuillez entrer le nouveau mot de passe et confirmez.",
  },

  error: {
    general: "Oups, une erreur s'est produite. Veuillez réessayer.",
    missingField: "Veuillez remplir tous les champs",
    passwordOrEmail: "Mot de passe ou e-mail incorrect",
    invalidEmail: "E-mail invalide",
    passwordConfirmation: "Les mots de passe sont différents",
    emailAlreadyRegistered: "Cet e-mail est déjà utilisé",
    userNotFound: "Utilisateur introuvable",
    websiteCredit:
      "Désolé, vous ne pouvez pas ajouter de sites supplémentaires avec l'offre en cours. Vous pouvez gérer les offres pour continuer.",
    pageCredit:
      "Désolé, vous ne pouvez pas ajouter de pages supplémentaires avec l'offre en cours. Vous pouvez gérer les offres pour continuer.",
    userAlreadyAdded: "Utilisateur déjà existant.",
  },

  btn: {
    reset: "Réinitialiser",
    login: "Se connecter",
    signUp: "S'inscrire",
    forgotPassword: "Mot de passe oublié",
    logOut: "Déconnexion",
    register: "Souscrire",
    viewAll: "Voir plus",
    learnMore: "En savoir plus",
    search: "Chercher",
    registerMyBusiness: "Inscrire mon entreprise",
    registerNow: "Souscrire",
    notMember: "Pas encore inscrit ?",
    update: "Mettre à jour",
    cancel: "Annuler",
    send: "Envoyer",
    back: "Retour",
    delete: "Supprimer",
    edit: "Éditer",
    contactUs: "Contactez-nous",
    about: "À propos",
    visitWebsite: "Voir le site",
    visit: "Voir",
    close: "Fermer",
    confirm: "Valider",
    seeAllCategories: "Voir toutes les catégories",
    addWebsite: "Ajouter un site",
    addPage: "Ajouter une page",
    addCompany: "Ajouter une entreprise",
    selectOffer: "Choisissez l'offre",
    manageOffer: "Gérer les offres",
    invoice: "Voir mes factures",
    deactivate: "Désactivé",
    addOffer: "Ajouter une offre",
    unsuscribe: "Se désabonner",
    activate: "Activer",
    seeMore: "Voir plus",
    addUser: "Ajouter utilisateur",
  },

  personalizedOffer: {
    plan: "Offre personnalisée",
    title: "Choisissez les options",
    first: "par site pendant 1 an",
    second: "pour 10 pages en plus pendant 1 an",
  },

  offerCard: {
    yearly: "Annuel",
  },

  orderSummary: {
    title: "Résumé de la commande",
    orderTitle: "Votre commande",
    recapTitle: "Résumé",
    footer:
      "Conditions de l'offre : l'offre est disponible pour une durée de 1 an uniquement valable pour une entreprise. Toutes les options supplémentaires ne sont pas incluses et doivent être ajoutées à votre compte.",
    menu: {
      offer: "Offre / Options",
      details: "Détails",
      quantity: "Quantité",
      price: "Prix",
    },
    recap: {
      total: "Total",
      tax: "TVA inclue",
    },
  },

  paymentConfirmation: {
    title: "Votre paiement a bien été effectué.",
    subtitle: "Vous pouvez désormais profiter de l'offre.",
    btn: "Retour à Mon Compte",
  },

  paymentError: {
    title: "Oh ! Une erreur s'est produite !",
    subtitle: "Veuillez réessayer plus tard",
    btn: "Retour à Mon Compte",
  },

  about: {
    first: {
      title: "À propos de 1 Top Search",
      subtitle: "1 Top Search : l'annuaire en ligne de sites internet professionnels",
      content:
        "<p>Nous sommes un annuaire en ligne qui référence de nombreux sites internet de professionnels de divers secteurs. L'objectif de cet annuaire est double. En effet, dans un premier temps, il permet aux utilisateurs de trouver des entreprises de différents domaines grâce à un outil de recherche performant. Ainsi, les internautes peuvent facilement trouver des professionnels. Ensuite, pour les entreprises, l'annuaire en ligne est une opportunité d'augmenter leur visibilité sur le net. Nous proposons différentes offres et packs dans le but de répondre aux besoins des professionnels en terme de visibilité.<br> <br> <br> De plus, toutes les informations fournies sur l'annuaire sont soumises à des contrôles afin de toujours vous proposer un contenu qualitatif. C'est pourquoi certaines informations (données de l'entreprise, lien du site internet...) sont contrôlées. Nous avons des outils performants qui nous permettent de modérer les informations de notre site.<br><br><br> Tous les contenus considérés comme non-profesionnels n'apparaîtront pas sur l'annuaire.<br><br><br>L'annuaire est constitué de plusieurs secteurs d'activité différents que vous pourrez retrouver dans notre base de donnée grâce à un outil de recherche. Cet outil fonctionne par mot-clé. Puis, parmi les mot-clé, il recherche la liste de mot-clé associés avec les références enregistrées sur 1 Top Search. Le résultat obtenu sera alors classé selon les publications les plus récentes.<br> <br> <br> Les entreprises référencées sur notre site doivent compléter toutes les informations demandées afin de ressortir dans les premiers résultats et d'avoir le plus de mots-clé associés. Ainsi, vous gagnerez en visibilité.<br> <br> <br> Vous pouvez gérer directement vos entreprises et sites internet à partir de votre compte utilisateur. L'utilisateur peut avoir plusieurs entreprsies référencées et une entreprise peut avoir plusieurs sites internet. Aussi, vous pouvez ajouter des pages spécifiques de votre site internet pour les mettre en avant et augmenter votre référencement sur les moteurs de recherche (SEO).</p>",
    },

    second: {
      title: "Pourquoi rejoindre 1 Top Search ?",
      content:
        "<p>Si vous êtes un profesionnel, une entreprise et que vous possédez un site internet, 1 Top Search est une solution qui améliorera votre positionnement et votre visibilité en ligne. AUjourd'hui, nous savons à quel point il est important d'être présent sur le net. Si vous enregistrez votre entreprise et votre site internet sur notre annuaire professionnel, vous serez plus visible, ce qui signifie que vous pourrez toucher de nouveaux clients potentiels et donc booster votre activité.<br> <br> <br>De plus, inscrire son entreprise ainsi que son site sur 1 Top Search augmentera votre référencement naturel (SEO) et améliorera votre positionnement sur les moteurs de recherche grâce aux mots-clé. Ainsi, si votre site est bien positionné sur Google, par exemple, vous aurez davantage de trafic sur celui-ci. C'est une excellente opportunité pour votre activité et pour accélerer votre réputation en ligne (ou e-réputation).<br> <br> <br> Notre objectif principal est d'offrir une meilleure visibilité en ligne à tous les professionnels de secteurs variés comme les hôtel et restaurants, le marketing et la communication, l'informatique etc. En parallèle, les internautes peuvent trouver les professionnels selon leur lieu et leur catégorie. En tant que professionel, vous avez certaines informations à fournir. Plus vous mettez d'information à propos de votre activité, plus vous serez visible sur notre annuaire en ligne et sur le web. Vous pouvez modifier à tout moment vos informations à partir de votre compte.<br> <br> <br> Aussi, vous pouvez souscrire à l'offre qui correspond le mieux à vos besoins. Si vous avez plusieurs sites internet et que vous souhaitez les promouvoir, c'est possible avec 1 Top Search. Vous avez également la possibilité de personnaliser votre offre grâce à différentes options. Enfin, notre annuaire en ligne permet d'améliorer la visibilité en ligne en augmantant le trafic sur votre site internet et en faisant la promotion de votre activité.</p>",
    },
  },

  websiteShow: {
    title: "Site internet",
    noPage: "Aucune page n'a été ajoutée pour ce site internet.",
  },

  breadcrumb: {
    account: "Mon compte",
    manageCompany: "Gestion des entreprises",
    manageWebsite: "Gestion des sites internet",
  },

  ManageOfferModal: {
    websiteTitle: "Désolée, l'offre en cours ne vous permet pas d'ajouter un site supplémentaire.",
    pageTitle: "Désolée, l'offre en cours ne vous permet pas d'ajouter de page supplémentaire.",
    subtitle: "Vous pouvez gérer l'offre de votre entreprise afin de poursuivre.",
  },

  selectOffer: {
    personalizedOffers: "Offres personnalisées",
  },

  companyWebsiteCard: {
    page: "Page",
  },

  manageOffer: {
    title: "Gestion des offres",
    title2: "Abonnements actuels",

    modal: {
      title: "Se désabonner",
      title2: "Êtes-vous sûr ?",
      subtitle:
        "Vous êtes désabonné, cependant l'offre est valide pendant 1 an et se terminera le ",
      subtitle2: "Veuillez patienter...",
      wait: "Merci de patienter.",
    },
  },

  status: {
    validated: "Validé",
    pending: "En attente",
    pendingFast: "Validation rapide en attente",
    denied: "Refusé",
    deactivated: "Désactivé",
    deleted: "Supprimé",
    unknow: "Inconnu",
  },

  invoices: {
    title: "Factures de l'entreprise",
    chekInvoice: "Voir la facture",
    noInvoices: "Aucune facture",
    date: "Date :",
  },

  faq: {
    title: "Foire Aux Questions",
    first: {
      title: "GÉNÉRAL",
      content:
        "<p class='faq__bloc-title'>À quoi sert 1 Top Search ?</p><br/><p>1 Top Search est un annuaire professionnel dont l'objectif est double. D'une part, il permet aux utilisateurs de trouver directement des professionnels de divers secteurs d'activité (santé, électricité, bâtiment, restauration, technologie etc.) en effectuant une recherche sur notre site car un outil de recherche performant.D'autre part, il permet aux professionnels de différent domaine d'inscrire leur entreprise ainsi que leur site internet et pages spécifiques afin de gagner en visibilité.</p><br/><br/><p class='faq__bloc-title' > Peut-on s'inscrire gratuitement ?<p/><br/><p>Tous les professionnels peuvent s'inscrire gratuitement en créant un compte utilisateur en renseignant nom, prénom, adresse email et mot de passe. Cette inscription gratuite vous permet d'inscrire votre entreprise, votre site internet ainsi qu'une page web dédiée.</p>",
    },
    second: {
      title: "OFFRE",
      content:
        "<p class='faq__bloc-title'>Quelles sont vos offres ? Quelles sont les avantages ?</p> <br/> <p>Nous avons plusieurs offres qui vous permettent de gagner en visibilité selon vos besoins. Chaque offre est rattachée à une entreprise et une entreprise peut souscrire à plusieurs offres.<br/><br/> - Le Pack Entreprise vous permet d'ajouter (en plus de l'inscription gratuite) 1 site internet ainsi que 10 pages spécifiques. L'avantage de cette offre est qu'elle vous permet d'augmenter votre référencement sur les moteurs de recherche (SEO).<br/><br/> - Le Pack Agency vous permet d'ajouter (en plus de l'inscription gratuite) 10 sites internet ainsi que 10 pages supplémentaires par site. Cela est avantageux si vous êtes une agence ou travaillez avec plusieurs entreprise qui souhaitent gagner en visibilité en ligne. Si vous souhaitez ajouter un site ou une page supplémentaire en plus de votre offre, vous pouvez le faire via les options personnalisées.</p><br/><br/><p class='faq__bloc-title'>Combien de temps l'offre est-elle valable ? Y a-t-il une durée d'engagement ? Peut-on résilier l'offre à tout moment ? </p><br/> <p>L'offre est valable pour une durée d'un an et est reconduite tacitement si vous ne la résilier pas. Vous pouvez résilier votre abonnement à l'offre dès que vous le souhaitez à partir de votre espace utilisateur. L'offre restera valable jusqu'à sa durée de fin de validité. La résiliation de votre offre entraînera la suspension de vos sites et pages, le cas échéant.</p>",
    },
    third: {
      title: "PAIEMENT",
      content:
        "<p class='faq__bloc-title'>Comment payer ?</p> <br/> <p>Vous pouvez régler par carte bancaire (carte Bleue, Visa, Eurocard/Mastercard, American express) ou par Paypal directement sur notre site <a>www.1top-search.com.</a> </p><br/><br/><p class='faq__bloc-title'>Le paiement est-il sécurisé ? </p><br/> <p>Le paiement par carte bancaire en ligne est entièrement sécurisé. Les numéros de votre carte sont transmis à notre serveur sécurisé par le protocole crypté SSL.Lors du paiement par carte bancaire, ce système contrôle automatiquement la validité des droits d'accès. Il crypte tous nos échanges, garantissant leur confidentialité. Vos numéros figurant sur votre carte bancaire ne sont jamais en possession de de 1 Top Search, ils sont saisis sur le serveur sécurisé de notre banque.</p>",
    },
    fourth: {
      title: "DONNÉES PERSONNELLES",
      content:
        "<p class='faq__bloc-title'>Pourquoi créer un compte ? </p> <br/> <p>Votre compte vous permet de : gérer vos entreprises, gérer vos site internet, gérer vos pages web et gérer vos offres et factures. Toutes les informations de votre compte 1 Top Search ne sont utilisées que dans le cadre de votre relation commerciale avec 1 Top Search. Ces informations ne sont jamais partagées avec des tiers ou revendues. Elles peuvent être modifiées par vous à n'importe quel moment grâce à la gestion de votre espace compte. Elles peuvent également être complètement supprimées de notre base de données sur simple demande.</p>",
    },
    fifth: {
      title: "COMMENT NOUS CONTACTER",
      content:
        "<p>Pour toute question, vous pouvez directement nous contacter via le formulaire de contact sur le site ou bien par email.</p>",
    },
  },

  legal: {
    title: "Mentions légales",
    subtitle: "Vous trouverez ci-dessous les mentions légales.",
    bloc: {
      title: {
        first: "INFORMATIONS LÉGALES ",
        second: "DROITS DE PROPRIÉTÉ INTELLECTUELLE",
        third: "COOKIES",
      },

      first:
        "<p class='legal__bloc-subtitle'>Éditeur : </p><p>1 Top Search.</p> <p class='legal__bloc-subtitle'> Adresse email : </p> <p>contact@1top-search.com</p><p class='legal__bloc-subtitle'> Réalisation et référencement : </p> <p> Subforce, agence web située à Barcelone.<br/> Site internet : <a href='http://www.subforce.io' target='_blank'>www.subforce.io</a><br/>Directeur de publication : Antoine Jouve</p><p class='legal__bloc-subtitle'>Hébergeur : </p><p>Amazon Web Services Limited Liability Company (LLC) dont le siège social est situé au P.O. Box 81226 Seattle, WA 98108-1226, USA</p><p class='legal__bloc-subtitle'>  Droits d'auteur et Copyright :</p><p></p>L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous droits de reproduction sont réservés, y compris pour les documents photographiques. La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication. <p class='legal__bloc-subtitle'> Informatique et liberté : </p> Le droit d'accès, de modification, de rectification et de suppression des données qui vous concernent (article 34 de la loi 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés) s'exerce auprès du Responsable de la publication.",

      second:
        "<p>Le Site et l'ensemble de son contenu (en particulier le nom de domaine, logos, tout élément graphique, textuel et informatique du Site dont notamment les arborescences, mises en forme, présentations, illustrations, photographies, et/ou tout autre document) sont protégés par les réglementations françaises et internationales relatives à la propriété intellectuelle. Tous droits réservés copyright © - depuis 2022. <br/><br/> En aucun cas, la navigation sur le Site, ou les mentions y figurant, ne peuvent être interprétées comme accordant une licence d'utilisation ou un quelconque droit d'utiliser ces éléments. <br/><br/> A ce titre, leurs représentations, reproductions, imbrications, diffusions et rediffusions, partielles ou totales, sont interdites (article L. 122-4 du Code de la propriété intellectuelle français). Toute personne y procédant sans pouvoir justifier d'une autorisation préalable et expresse du détenteur de ces droits encourt les peines relatives au délit de contrefaçon (articles L. 335-2 et suivants du Code de la propriété intellectuelle français). L'Editeur pourra se prévaloir de ses droits, en particulier de propriété intellectuelle, pour engager desp oursuites notamment pénales.<br/><br/>1 Top Search se réserve le droit d'améliorer ou de modifier à tout moment les informations, produits, programmes ou conditions d'utilisation décrits dans le Site, et ce sans que sa responsabilité puisse être engagée de ce fait. Les conditions et mentions applicables seront celles en vigueur à la date de votre connexion au Site.</p>",

      third:
        "<p>1 Top Search se réserve le droit d’utiliser des cookies pour son bon fonctionnement. L’utilisateur est informé que lors de ses visites sur le site <a href='http://www.1top-search.com' target='_blank'>www.1top-search.com</a>, un ou plusieurs cookies peuvent s’installer automatiquement sur son logiciel de navigation.</p><br><p>Le cookie est un bloc de données qui ne permet pas d’identifier les utilisateurs   mais sert à enregistrer des informations relatives à la navigation de celui-ci sur le site.</p><br><p>Le paramétrage du logiciel de navigation permet d’informer de la présence de cookie et éventuellement, de la refuser.</p>",
    },
  },

  security: {
    title: "Politique de confidentialité",
    subtitle: "Vous trouverez ci-dessous notre politique de confidentialité.",
    content:
      "<p>Cette rubrique est consacrée à notre Politique de Confidentialité. Elle vous permet d'en savoir plus sur l'origine et l'usage des informations de navigation traitées lorsque vous consultez notre site et de vos droits.<br/><br/>Les informations suivantes vous sont communiquées afin que vous puissiez prendre connaissance des engagements en matière de protection des données à caractère personnel par 1 Top Search, qui agit en tant que responsable du traitement pour les traitements de données à caractère personnel évoqués dans le présent document.<br/><br/><br/><p class='privacy__content-title'>Importance de la protection de votre vie privée</p><br/>Le traitement de données à caractère personnel et les données collectées par 1 Top Search ne sont pas réutilisées par une société tierce ni revendues.<br/><br/>Notre politique de confidentialité est pertinente pour tout utilisateur qui partage ses données personnelles directement ou indirectement sur le Site de quelle manière qui soit. <br/><br/>- L'utilisateur a créé un compte sur 1 Top Search (mode actif) en déclarant son identité professionnelle.<br/><br/>- Le visiteur, consulte le site 1 Top Search (mode passive) pour visualiser des informations professionnelles.<br/><br/><br/><p class='privacy__content-title'>Données collectées</p><br/>Toutes les informations collectés sont visibles depuis les différents formulaires de création (compte personnel, entreprise, sites internet, page internet).  <br/><br/>Pour créer un compte utilisateur 1 Top Search, vous devez indiquer nom, prénom, adresse email ainsi qu'un mot de passe.<br/><br/>Après avoir créer votre compte, vous accédez à un espace privé, personnel qui vous permet de : gérer vos entreprises, gérer vos sites internet, gérer vos pages web et gérer vos offres et vos factures.<br/><br/>Ne publiez que des données personnelles que vous acceptez de rendre publiques.<br/><br/><br/><p class='privacy__content-title'>Conservation des données</p><br/>Nous conservons les données personnelles tant que votre compte utilisateur est actif, c'est à dire qu'il existe.<br/><br/>Pour supprimer vos données, il vous suffit d'envoyer un e-mail à l'adresse suivante.Pour modifier ou rectifier des données, vous pouvez modifier vous-même les données personnelles parle biais de espace utilisateur 1 Top Search.<br/><br/>Pour toutes questions relatives à la protection des données, contactez-nous.</p>",
  },

  cgv: {
    title: "Conditions Générales de Vente",
    subtitle: "Vous trouverez ci-dessous les termes et conditions.",
    content:
      "<p><p class='privacy__content-title'>APPLICATION DES CGV</p>Les présentes conditions générales de ventes sont applicables aux utilisateurs du site <br/><a href='http://www.1top-search.com' target='_blank'>www.1top-search.com.</a><br/><br/>Toute utilisation et paiement validé sur le site implique l'adhésion pleine et entière aux présentes conditions générales de ventes. <p class='privacy__content-title'>VUE D'ENSEMBLE</p>Les termes “nous”, “notre” et “nos” suivants font référence à 1 Top Search. Nous proposons ce site web, y compris toutes les informations, tous les outils et services qui y sont disponibles pour les utilisateurs sous réserve de l'acceptation de l'ensemble des modalités et conditions suivantes.<br/><br>En visitant ce site et/ou en souscrivant à nos offres, vous vous engagez dans notre “Service” et acceptez d'être lié par les “Conditions Générales de Vente” y compris les modalités et conditions additionnelles auxquelles il est fait référence ici. Ces Conditions Générales de Vente s'appliquent à tous les utilisateurs qui naviguent sur le site.<br/><br/>Nous nous réservons le droit de mettre à jour, de changer ou de remplacer toute partie de ces Conditions Générales de Vente sur notre site web. Il vous incombe de consulter cette page régulièrement pour vérifier si des modifications ont été apportées. Votre utilisation continue du site web ou votre accès à celui-ci après la publication de toute modification constitue une acceptation de votre part de ces modifications.<p class='privacy__content-title'>CONDITIONS GÉNÉRALES</p>Vous acceptez de ne pas reproduire, dupliquer, copier, vendre, revendre ou exploiter une quelconque partie du Service ou utilisation du Service, ou un quelconque accès au Service ou contact sur le site web, par le biais duquel le Service est fourni, sans autorisation écrite expresse préalable de notre part.<p class='privacy__content-title'>MODIFICATION DU PRIX</p>Nous nous réservons le droit de modifier le prix des offres à tout moment, et sans préavis. L'offre vous sera facturée sur la base des tarifs en vigueur au moment de la souscription à l'offre. L'offre est valable à partir du moment où le paiement a bien été accepté.<br/><p class='privacy__content-title'>OFFRES</p>Toutes les descriptions des offres et tous les prix peuvent être modifiés en tout temps sans avis préalable, à notre seule discrétion.<br/>Nous ne garantissons pas que l'offre, les services, ou toute autre information que vous avez obtenue ou achetée répondra à vos attentes.<br/><p class='privacy__content-title'>EXACTITUDE DE LA FACTURATION ET DES INFORMATIONS DE COMPTE</p>Vous acceptez de fournir des informations paiement et de compte à jour, complètes et valides pour toutes les paiements effectués. Vous vous engagez à mettre à jour rapidement les informations sur votre compte, y compris votre adresse e-mail, vos numéros de cartes de crédit et dates d'expiration, pour que nous puissions compléter vos transactions et vous contacter si nécessaire.<p class='privacy__content-title'>DURÉE DE L'OFFRE</p>L'offre est valable pour une durée de 1 an minimum à compter de la date de paiement effectué.<p class='privacy__content-title'>RÉSILIATION</p>Ces Conditions Générales de Vente sont effectives jusqu'à ce qu'elles soient résiliées. Vous pouvez résilier ces Conditions Générales de Vente à tout moment en nous avisant que vous ne souhaitez plus utiliser nos Services, ou lorsque vous cessez d'utiliser notre site.<br/><br/>L'offre est tacitement reconductible tous les ans sauf résiliation pouvant intervenir à tout moment et au plus tard à sa date de fin de validité qui figure dans la rubrique « Mon Compte », sur la page « Gestion des entreprises».<br><br>Toute résiliation devra être notifiée via le bouton « Se désabonner » accessible dans la rubrique « Mon compte », sur la page « Gestion des entreprises»<br><br>La résiliation prendra effet après la date de fin de validité de l'offre en cours.<br><br>Nous disposons de la faculté de résilier et/ou suspendre l'accès à nos offres de plein droit dans les cas suivants : <br>- en cas de non-paiement par le Client de la ou des paiement dus au titre de l'offre.<br>- au cas où les informations communiquées par l'utilisateur dans le cadre de la souscription à l'offre sont incomplètes, inexactes, invalides ou obsolètes.<br><br>Cette résiliation/suspension entraînera la désactivation immédiate de l'offre sur notre site sans droit à indemnité ni à un remboursement. L'utilisateur sera notifié de cette décision.<p class='privacy__content-title'>TARIF ET MODALITÉS DE PAIEMENT</p>L'offre implique le paiement par l'utilisateur d'un prix annuel forfaitaire communiqué à l'utilisateur préalablement à la souscription de son offre. Les prix sont indiqués toutes taxes comprises au taux en vigueur au jour de la souscription.<br><br>Toute modification du prix annuel forfaitaire visé au présent article sera portée à la connaissance de l'utilisateur au moins un mois avant son entrée en vigueur. Dans ce cas, l'utilisateur aura la faculté de résilier son offre sans frais, dans les conditions prévues ci-dessus.<br><br>L'utilisateur reconnaît et accepte que, en communiquant les informations relatives à sa carte bancaire, il autorise 1 Top Search à débiter sa carte bancaire lors du renouvellement annuel de son offre.<p class='privacy__content-title'>LOI APPLICATION</p>Ces Conditions Générales de Vente sont régies et interprétées en vertu des lois en vigueur française.<p class='privacy__content-title'>LITIGES</p>Le droit applicable est le droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>",
  },

  cookies: {
    text: "Nous utilisons des cookies sur notre site web afin de vous offrir la meilleure expérience de navigation.",
    btn: "En savoir plus.",
  },

  addUserModal: {
    title: "Ajouter un utilisateur à cette entreprise",
    label: "Email de l'utilisateur",
    confirm: "L'utilisateur a bien été ajouté.",
    addMore: "Ajouter un autre",
  },

  metadata: {
    home: {
      title: "1 Top Search : annuaire en ligne de sites professionnels | 1 Top Search",
      description:
        "1 Top Search : annuaire de sites internet professionnels qui améliore la visibilité des entreprises en ligne. Trouvez des entreprises de divers secteurs avec l'annuaire en ligne.",
    },
    categories: {
      title: "Catégories : secteurs des professionnels | annuaire 1 Top Search",
      description:
        "Recherchez un site internet professionnel par catégorie. Trouvez des sites d'entreprises de différents secteurs en faisant une recherche sur l'annuaire en ligne.",
    },
    offers: {
      title: "Nos offres pour gagner en visibilité en ligne | annuaire 1 Top Search",
      description:
        "Offres adaptées à vos besoins : inscription gratuite, pack simple ou multiple, offres personnalisées pour bénéficier davantage de visibilité en ligne sur l'annuaire.",
    },
    about: {
      title: "À propos de 1 Top Search, l'annuaire professionnel en ligne | 1 Top Search",
      description:
        "En savoir plus sur l'annuaire professionnel en ligne. Pourquoi inscrire son entreprise sur 1 Top Search ? Quels sont les avantages ? À quoi sert 1 Top Search ?",
    },
    aboutWebsite: {
      title: "{#name} - à propos : sites et pages | annuaire 1 Top Search",
    },
    register: {
      title: "Inscription : inscrire son entreprise et gérer ses sites | 1 Top Search",
      description:
        "Créez un compte, inscrivez votre entreprise, vos sites internet et pages web sur l'annuaire professionnel 1 Top Search. Souscrivez aux offres et gérer vos informations.",
    },
    login: {
      title: "Connexion : connectez-vous à votre compte | annuaire 1 Top Search",
      description:
        "Connectez-vous à votre compte pour gérer vos entreprises, sites internet, pages web, vos offres, modifier vos informations personnelles, changer votre mot de passe...",
    },
    account: {
      title: "Mon compte : gérer et ajouter des entreprises | annuaire 1 Top Search",
      description:
        "Gérez votre compte : éditez vos informations, gérez vos entreprises, ajoutez une nouvelle entreprise, ajoutez des sites et des pages web à partir de votre compte.",
    },
    contact: {
      title: "Contact : contactez-nous via le formulaire | annuaire 1 Top Search",
      description:
        "Pour nous contacter, veuillez remplir directement le formulaire de contact sur notre site 1 Top Search. Notre équipe est disponible pour répondre à toutes vos questions.",
    },
    faq: {
      title: "Foire Aux Questions : on vous répond | 1 Top Search",
      description:
        "On répond à toutes vos questions : à quoi sert 1 Top Search ? Pourquoi inscrire son entreprise sur l'annuaire ? Nos offres, les avantages, le paiement...",
    },
    resetPassword: {
      title: "Réinitialiser mot de passe | Annuaire entreprise en ligne 1 Top Search",
      description:
        "Mot de passe oublié ? Réinitialisez votre mot de passe et créez-en un nouveau. Entrez votre adresse email puis cliquez sur le lien reçu par email pour réinitialiser votre mot de passe.",
    },
    orderSummary: {
      title: "Résumé de votre commande | Annuaire entreprise en ligne 1 Top Search",
      description:
        "Retrouvez les détails de votre commande avec les offres et options auxquels vous avez souscrit ainsi que la quantité et le prix. Puis, confirmez votre commande.",
    },
    paymentConfirmation: {
      title: "Confirmation de paiement | Annuaire entreprise en ligne 1 Top Search",
      description:
        "Nous confirmons que votre paiement a été réalisé avec succès. Vous pouvez dès à présent profiter de votre offre et options et inscrire votre entreprise, site internet et pages.",
    },
  },
};
